import * as SubsidyRejectPopup from './SubsidyRejectPopup.css';

export default {
	SubsidyRejectPopup
};
